import _ from "lodash";

/**
 * @description 입력 크기 만큼 메모리 여유 공간 여부 확인
 * @function hasFreeMemoryCapacity
 *
 * @param {number} freesize
 *
 * @return {boolean} true 여유공간있음
 *         {boolean} false : 여유공간없음
 */
function hasFreeMemoryCapacity(freesize) {
  const testHeapsizeLimitAPI = _.get(performance, "memory.jsHeapSizeLimit");
  const testUsedHeapSizeAPI = _.get(performance, "memory.usedJSHeapSize");

  // 메모리 사용량 측정을 위한 API의 지원 여부 확인.
  // 지원되지 않을 시, true 반환
  if (testHeapsizeLimitAPI === undefined || testUsedHeapSizeAPI === undefined) {
    return true;
  }

  // 메모리 사용량을 측정하여, fresize 만큼 여유 공간이 있는지 확인
  // 여유 공간이 있다면, true 반환
  // 여유 공간이 없다면, false 반환
  const memoryLimit = performance.memory.jsHeapSizeLimit; // will give you the JS heap size
  const usedMemory = performance.memory.usedJSHeapSize; // how much you're currently using

  if (usedMemory + freesize >= memoryLimit) {
    // freesize만큼 여유 공간이 없음.
    return false;
  }
  // freesize이상 여유 공간이 있음
  return true;
}

export { hasFreeMemoryCapacity };
